import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from 'app/common/toast-alert/toast.service';
import { OrganizationType } from 'app/globals-classes/OrganizationType';
import { GlobalsService } from 'app/globals-services/globals.service';
import { BrandFactoryConnectionService } from 'app/shared/services/brand-factory-connection.service';

@Component({
  selector: 'app-searched-list',
  templateUrl: './searched-list.component.html',
  styleUrls: ['./searched-list.component.scss']
})
export class SearchedListComponent implements OnInit {

  constructor(
    public globalsService: GlobalsService,
    private toastService: ToastService,
    private translateService:TranslateService,
    private brandFactoryConnectionService: BrandFactoryConnectionService) { }

  ngOnInit(): void {

    this.fetchTranslations();
    this.translateService.onLangChange.subscribe(() => {
        this.fetchTranslations();
    });
  }

  // @ Search Functionality Here, Search By Brand Name  TAB 3 Logic

  supplierList: any = [];

  brands: any[] = [];
  searchResultList: any[] = [];
  totalCount: any = 0;

  localBrandList: any = [];
  brandList: any = [];
  inputText: string;

  alertMsgs={}


  searchDataSource: MatTableDataSource<any> = null;

  searchResultDisplayedColumns = [
    'Name',
    'address',
    'countryName',
    'Connection Status'
  ];

  fetchTranslations(){
    this.translateService
    .get('BRAND_FACTORY_CONNECTION_COMPONENT.MESSAGES')
    .subscribe((response) => {
        this.alertMsgs = response;
    });
  }


  onSupplierSearch() {
    // this.inputText = event.target.value;

    if (this.inputText.length == 0) {
      this.localBrandList = [];
      this.supplierList = [];
    }

    if (this.localBrandList.length != 0) {
      this.localBrandList = this.supplierList.filter((res) => {
        return res.name.toLowerCase().match(this.inputText.toLocaleLowerCase());
      });

      this.supplierList = this.localBrandList;
    }

    if (this.localBrandList.length === 0) {
      let data = {
        searchString: this.inputText,
        requestFrom: this.globalsService.profile['id']
      };

      if (this.inputText.length != 0) {
        this.globalsService.showSpinner();

        // Call API if  Organization are Factory
        if (this.globalsService.profile['organization_type'] ==  OrganizationType.SUPPLIER) {
          this.brandFactoryConnectionService.searchBrandByList(data).subscribe(
            (response) => {
              if (response) {
                
                this.searchResultList = response;
                this.localBrandList = response;
                this.searchDataSource = new MatTableDataSource(this.searchResultList);
                this.globalsService.hideSpinner();
              }
            },
            (error) => {
              this.globalsService.hideSpinner();
            }
          );

        } else
          // Call API if  Organization are Brand
          if (this.globalsService.profile['organization_type'] == OrganizationType.BRAND || this.globalsService.profile['organization_type'] == OrganizationType.IMPORTER) {
            this.brandFactoryConnectionService.searchFactoryByList(data).subscribe(
              (response) => {
                if (response) {
                  
                  this.searchResultList = response;
                  this.localBrandList = response;
                  this.searchDataSource = new MatTableDataSource(this.searchResultList);
                  this.globalsService.hideSpinner();
                }
              },
              (error) => {
                this.globalsService.hideSpinner();
              }
            );

          }

      }
    }
  }

  // connectionForm: FormGroup = new FormGroup({
  //   supplierName: new FormControl('', Validators.minLength(2))
  // });

  sendConnectionRequest(selectedRow) {

    let data = {
      requestFrom: this.globalsService.profile['id'],
      requestTo: selectedRow.id
    }

    this.globalsService.showSpinner()
    this.brandFactoryConnectionService.addConnectionRequest(data).subscribe(
      (response) => {

        if (response['status'] === 'SUCCESS'){
          this.globalsService.hideSpinner()
          this.toastService.success(this.alertMsgs['CONNECTION_SEND_SUCCESS_ALERT'])
          this.onSupplierSearch();
          this.brandFactoryConnectionService.commonSubject$.next({ loadLatestConnection: true })
        }
        else{
          this.globalsService.hideSpinner()
          this.toastService.error(this.alertMsgs['UNKNOWN_ERROR_ALERT'])
        }
        
        
      },
      (error) => {
        this.globalsService.hideSpinner()
        this.toastService.error(this.alertMsgs['UNKNOWN_ERROR_ALERT'])
      }
    );
  }

  checkAndClearList(ev){
    if(this.inputText==null || this.inputText.length==0){
      this.searchResultList=[]
      this.searchDataSource =null;
      // new MatTableDataSource([]);
    }
  }
}
